import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarcode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBarcode"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H8V5.5H3.5V10H2V4ZM16 4H22V10H20.5V5.5H16V4ZM8.5 9V15H7V9H8.5ZM12.75 9V13H11.25V9H12.75ZM17 9V15H15.5V9H17ZM3.5 14V18.5H8V20H2V14H3.5ZM22 14V20H16V18.5H20.5V14H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarcode;
